/* eslint-disable no-console */

import { register } from 'register-service-worker';

function clearCachesAndReload() {
  if ('caches' in window) {
    caches.keys()
      .then(names => Promise.all(names.map(name => caches.delete(name))))
      .then(() => window.location.reload(true));
  } else {
    window.location.reload(true);
  }
}

if (process.env.NODE_ENV === 'production') {
  window.addEventListener('error', (event) => {
    const target = event.target;
    const tag = target && target.tagName;
    if (tag !== 'SCRIPT' && tag !== 'LINK') return;

    const src = target.src || target.href || '';
    const isLocalAsset = src && src.startsWith(window.location.origin);
    if (!isLocalAsset) return;

    // Evitar loop infinito, vai tenta limpar cache uma vez por sessão
    if (sessionStorage.getItem('sw-reload-attempted')) { 
      return;
    }
    sessionStorage.setItem('sw-reload-attempted', '1');

    console.warn('Chunk load error detected, clearing SW cache and reloading.');
    clearCachesAndReload();
  }, true);

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is being served from cache by a service worker.');
    },
    registered() {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated() {
      console.log('New content is available; clearing cache and reloading.');
      // clearCachesAndReload();
      //window.dispatchEvent(new CustomEvent('sw-updated'));
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}
